/* ============================================================
   RELAX THE BACK — ERGONOMIC OFFICE LP
   assets/office-lp.js

   Behaviour only. All product and review markup is rendered
   server-side by sections/office-lp.liquid, so there is no data
   layer here to drift out of sync with the catalogue.

   Loaded with `defer`, and every lookup is guarded, so the file is
   safe if a block is removed from the section.
   ============================================================ */
(function () {
  'use strict';

  /* =========================================================
     CAROUSELS
     ========================================================= */
  document.querySelectorAll('.rail-foot, .sec-head').forEach(foot => {
    const nav = foot.querySelector('.rail-nav');
    if(!nav) return;
    const targetId = nav.querySelector('[data-for]')?.dataset.for;
    const rail = targetId ? document.getElementById(targetId)
               : foot.closest('section').querySelector('[data-rail]');
    if(!rail) return;
    const bar = foot.querySelector('.rail-prog span');
    const btns = nav.querySelectorAll('.rnav');

    const step = () => {
      const first = rail.firstElementChild;
      if(!first) return 320;
      return first.getBoundingClientRect().width + parseFloat(getComputedStyle(rail).gap || 24);
    };
    const sync = () => {
      const max = rail.scrollWidth - rail.clientWidth;
      if(bar){
        const visible = Math.max(12, (rail.clientWidth / rail.scrollWidth) * 100);
        bar.style.width = visible + '%';
        bar.style.left = (max > 0 ? (rail.scrollLeft / max) * (100 - visible) : 0) + '%';
      }
      btns[0].disabled = rail.scrollLeft <= 2;
      btns[1].disabled = rail.scrollLeft >= max - 2;
    };
    btns.forEach(b => b.addEventListener('click', () => {
      rail.scrollBy({left: step() * Number(b.dataset.dir) * (window.innerWidth > 900 ? 2 : 1), behavior:'smooth'});
    }));
    rail.addEventListener('scroll', sync, {passive:true});
    window.addEventListener('resize', sync);
    setTimeout(sync, 60);
  });

  /* =========================================================
     HOTSPOTS
     ========================================================= */
  document.querySelectorAll('[data-hotspots] .hs').forEach(hs => {
    const open = () => {
      document.querySelectorAll('.hs').forEach(o => o !== hs && o.classList.remove('is-open'));
      hs.classList.add('is-open');
    };
    const btn = hs.querySelector('.hs__dot');
    const canHover = () => window.matchMedia('(hover:hover)').matches;

    /* Nothing is open on load. On pointer devices hover is the only driver, so a
       click can't leave a tip stuck open. Touch devices have no hover, so there
       the tap toggles it. Keyboard focus opens it either way. */
    btn.addEventListener('click', e => {
      e.stopPropagation();
      if (canHover()) return;
      const was = hs.classList.contains('is-open');
      document.querySelectorAll('.hs').forEach(o => o.classList.remove('is-open'));
      if (!was) hs.classList.add('is-open');
    });
    btn.addEventListener('focus', open);
    btn.addEventListener('blur', () => hs.classList.remove('is-open'));
    hs.addEventListener('mouseenter', () => canHover() && open());
    hs.addEventListener('mouseleave', () => canHover() && hs.classList.remove('is-open'));
  });
  document.addEventListener('click', () => document.querySelectorAll('.hs').forEach(o => o.classList.remove('is-open')));

  /* =========================================================
     SCROLL REVEAL
     ========================================================= */
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if(e.isIntersecting){ e.target.classList.add('is-in'); io.unobserve(e.target); } });
  }, {rootMargin:'0px 0px -8% 0px', threshold:.06});
  document.querySelectorAll('.rv').forEach(el => io.observe(el));

  /* =========================================================
     STEP PROGRESS + STICKY MOBILE CTA
     ========================================================= */
  /* only the step list — not the CTA that also lives in the bar */
  const stepLinks = [...document.querySelectorAll('#stepbar .steps a')];
  const pairs = stepLinks
    .map(a => ({a, s: document.querySelector(a.getAttribute('href'))}))
    .filter(p => p.s)
    .sort((x, y) => x.s.offsetTop - y.s.offsetTop);

  /* Deterministic: the last section whose top has crossed the read-line wins,
     so scrolling in either direction always resolves the same way. */
  let queued = false;
  function setActive(){
    queued = false;
    const line = window.innerHeight * 0.35;
    let current = null;
    for(const p of pairs){
      if(p.s.getBoundingClientRect().top <= line) current = p;
    }
    pairs.forEach(p => p.a.classList.toggle('is-active', p === current));
  }
  const onScroll = () => { if(!queued){ queued = true; requestAnimationFrame(setActive); } };
  addEventListener('scroll', onScroll, {passive:true});
  addEventListener('resize', onScroll);
  setActive();

  /* sticky mobile CTA — reveals once the hero scrolls away */
  const mob = document.getElementById('mobcta');
  const hero = document.querySelector('.hero');
  if (mob && hero) {
    new IntersectionObserver(([e]) => mob.classList.toggle('is-in', !e.isIntersecting), {threshold:0})
      .observe(hero);
  }
})();
